import { createListeners } from '/store/layout'
export default ({ app, store }, inject) ->

	# Keep VueX up to date
	{ onResize } = createListeners store
	inject 'onResize', onResize
